<template>
    <div class="my-5" v-for="(bien, index) in biens" :key="index">
        <hr class="border-gray-200 dark:border-gray-800">
        <div class="flex justify-between justify-items-center items-center mt-4">
            <div>
                <router-link  :to="`/bien/${bien.uuid}`">
                    <h3 class="text-indigo-500 dark:text-indigo-400 cursor-pointer hover:text-indigo-700 dark:hover:text-indigo-300 inline-block text-lg">{{bien.libelle}}</h3>

                    <div class="mt-1 text-sm font-normal text-gray-500 dark:text-gray-400">
                        <p>{{ bien.ville }}<template v-if="bien.ville && bien.cp"> - </template>{{ bien.cp }}</p>
                        <p>{{ bien.adresse }}</p>
                    </div>
                </router-link>
            </div>
            <div v-if="bien.total_cumule !== undefined && bien.total_cumule !== null" class="text-right shrink-0 ml-4">
                <span class="text-xs text-gray-400 dark:text-gray-500">Total cumulé</span>
                <p class="text-base font-semibold" :class="bien.total_cumule >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'">{{ formatMoney(bien.total_cumule) }}</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        biens: {
            type: Array,
            default() {
                return []
            }
        },
    },

    methods: {
        formatMoney(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }
    }
};
</script>